import useAccountRestriction from "../account/useAccountRestriction";
import { useCurrentUser } from "../user/useCurrentUser";
import useRequiresApprovals from "./useRequiresApprovals";

interface Return {
  isApprovalRequired: boolean;
  isLoading: boolean;
}

export function useIsApprovalRequiredForZaps({
  zapIds,
}: {
  zapIds: string[];
}): Return {
  const { user } = useCurrentUser();
  const {
    isPublishApprovalEnabled,
    isLoading: isAccountRestrictionLoading,
    isPending: isPendingAccountRestrictionLoading,
  } = useAccountRestriction();
  const {
    zaps,
    isLoading: isLoadingRequiresApprovals,
    isPending: isPendingRequiresApprovals,
  } = useRequiresApprovals({
    zapIds,
  });

  const isApprovalRequired =
    isPublishApprovalEnabled &&
    zaps.some((zap) => {
      return (
        zap.requiresApproval &&
        !zap.approvers.some((approver) => approver.email === user?.email)
      );
    });

  return {
    isApprovalRequired: isApprovalRequired || false,
    isLoading:
      isAccountRestrictionLoading ||
      isLoadingRequiresApprovals ||
      isPendingRequiresApprovals ||
      isPendingAccountRestrictionLoading,
  };
}
